import React, { useEffect, useState } from "react";
import styles from "./DashFavoriteListings.module.css";
import { useAuth } from "../../../../contexts/AuthContext";
import { listingStates } from "../../../../util/flStates";
import axios from "axios";
import { Button } from "@mui/material";
import Listing from "../../../Listing/Listing";
import { toast } from "react-toastify";

function DashFavoriteListings() {
  const { accessToken } = useAuth();
  const [sellFavoriteListings, setSellFavoriteListings] = useState([]);
  const [rentFavoriteListings, setRentFavoriteListings] = useState([]);
  const [listingType, setListingType] = useState(listingStates.rent);
 
  useEffect(() => {
    const fetchFavoriteListings = async () => {
      try {
        if (!accessToken) {
          toast.error("Access token is missing. Please log in.");
          return;
        }

        // Call the /favorites/details API endpoint
        const response = await axios.get(
          `${import.meta.env.VITE_BACKEND_URL}/listings/favorites/details`,
          {
            headers: {
              Authorization: accessToken,
            },
          }
        );

        if (response.status === 200 && response.data.success) {
          const favoriteListings = response.data.favorites || [];

          // Add isFavorite: true to all listings
          const updatedListings = favoriteListings.map((listing) => ({
            ...listing,
            isFavorite: true,
          }));

          // Separate listings into rent and sell categories
          const liveRentListings = updatedListings.filter(
            (listing) =>
              listing.rent_price !== null && listing.rent_price !== undefined
          );

          const liveSellListings = updatedListings.filter(
            (listing) =>
              listing.sell_price !== null && listing.sell_price !== undefined
          );

          setRentFavoriteListings(liveRentListings);
          setSellFavoriteListings(liveSellListings);
        } else {
          const errorMsg =
            response.data.message || "Error fetching favorite listings.";
          toast.error(errorMsg);
        }
      } catch (error) {
        toast.error(
          "An error occurred while fetching favorite listings. Please try again!"
        );
      }
    };

    fetchFavoriteListings();
  }, [accessToken]);

  const handleBookmarkToggle = async (listingId, isBookmarked) => {
    //console.log("BB", listingId, isBookmarked);
    try {
      if (isBookmarked) {
        // Remove the listing from favorites
        await axios.delete(
          `${import.meta.env.VITE_BACKEND_URL}/listings/favorites/${listingId}`,
          {
            headers: { Authorization: accessToken },
          }
        );
        // console.log("Listing removed from favorites!");
      } else {
        // Add the listing to favorites
        await axios.post(
          `${import.meta.env.VITE_BACKEND_URL}/listings/favorites/${listingId}`,
          {},
          {
            headers: { Authorization: accessToken },
          }
        );
        // console.log("Listing added to favorites!");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        // Show a toast error message for unauthorized users
        toast.error("You should be logged in to bookmark listings.");
      } else {
        console.error("Error toggling bookmark status:", error);
        toast.error("An error occurred while updating the bookmark status.");
      }
    }
  };

  return (
    <div>
      <div>
        <h1 className={styles.title}>Favorite</h1>
      </div>
      <div className={styles.sectionContainer}>
        <div>
        <h1 className={styles.mainTitle}>Manage your favorite listings here</h1>
        </div>
        <div className={styles.showlistingsContainer}>
          {/* <h2>View your favorite listings</h2> */}
          {rentFavoriteListings.length > 0 || sellFavoriteListings.length > 0 ? (
            <div>
              <div className={styles.rentSellSelectionContainer}>
                <div className={styles.rentSellSelectionBox}>
                  <Button
                    className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionLeft}`}
                    variant={
                      listingType === listingStates.rent
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => setListingType(listingStates.rent)}
                  >
                    Rent
                  </Button>
                  <Button
                    className={`${styles.rentSellSelectionOption} ${styles.rentSellSelectionOptionRight}`}
                    variant={
                      listingType === listingStates.sell
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => setListingType(listingStates.sell)}
                  >
                    Sell
                  </Button>
                </div>
              </div>
              <div>
                {listingType === listingStates.rent ? (
                  rentFavoriteListings.length > 0 ? (
                    <ul className={styles.listingsContainer}>
                      {rentFavoriteListings.map((listing, index) => (
                        <Listing
                          key={index}
                          listing={listing}
                          handleBookmarkToggle={handleBookmarkToggle}
                        />
                      ))}
                    </ul>
                  ) : (
                    <div className={styles.noListingsMessage}>
                      You have no favorite rent listings.
                    </div>
                  )
                ) : sellFavoriteListings.length > 0 ? (
                  <ul className={styles.listingsContainer}>
                    {sellFavoriteListings.map((listing, index) => (
                      <Listing
                        key={index}
                        listing={listing}
                        handleBookmarkToggle={handleBookmarkToggle}
                      />
                    ))}
                  </ul>
                ) : (
                  <div className={styles.noListingsMessage}>
                    You have no favorite sell listings.
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className={styles.noListingsMessage}>
              You do not have any favorite listings yet.
            </div>
          )}
          </div>
        </div>
    </div>
  );
}

export default DashFavoriteListings;
